import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Label } from 'semantic-ui-react'
import { useSelector } from "react-redux";
import { filter } from 'lodash';
import { Navigate } from 'react-router-dom';
import Scrollbar from '../../components/scrollbar';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import './style.css';
import {
  Card,
  Table,
  Button,
  Switch,
  FormControlLabel,
  Checkbox,
  Stack,
  Paper,
  Avatar,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  FormControl,
  TextField
} from '@mui/material';
import { Link } from 'react-router-dom';
import SelectHuntingClub, { components } from 'react-select';
import SelectVrstaClanstva from 'react-select';
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';

const TABLE_HEAD = [
  { id: 'id', label: 'Broj', alignRight: false },
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'prezime', label: 'Prezime', alignRight: false },
  { id: 'mjesto', label: 'Mjesto', alignRight: false },
  { id: 'drzava', label: 'Država', alignRight: false },
  { id: 'datumregistracije', label: 'Registrovan', alignRight: false },
  { id: 'select', label: 'Select', alignRight: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, field) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
	if (field === 'ime')
    return filter(array, (_user) => (_user.ime.toLowerCase()+ ' ' +_user.prezime.toLowerCase()).indexOf(query.toLowerCase()) !== -1);

	if (field === 'prezime')
    return filter(array, (_user) => _user.prezime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'telefon')
    return filter(array, (_user) => _user.telefon.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'mjesto')
    return filter(array, (_user) => _user.mjesto.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'drzava')
    return filter(array, (_user) => _user.drzava.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'username')
    return filter(array, (_user) => _user.username.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
}
  
export default function Update(props) {
	
	const navigate  = useNavigate();
	
	const [id, setId] = useState(localStorage.getItem('id'));	
	const [subscriberId, setSubscriberId] = useState(localStorage.getItem('subscriberId'));
	const [ime, setIme] = useState('');
	const [tip, setTip] = useState('');
	const [IMEI, setIMEI] = useState('');
	const [tiptrackera, setTiptrackera] = useState('');
	const [brojmobitela, setBrojmobitela] = useState('');
	const [bojaputanje, setBojaputanje] = useState('');
	const [uploadinterval, setUploadinterval] = useState('');
	const [needreset, setNeedreset] = useState('');
    const [needdisconnect, setNeeddisconnect] = useState('');
	const [workmode, setWorkmode] = useState('');
	const [setuploadinterval, setSetuploadinterval] = useState('');
	const [blokiran, setBlokiran] = useState('');
	const [datumstart, setDatumstart] = useState('');
	const [datumend, setDatumend] = useState('');
	const [datumlast, setDatumlast] = useState('');
	const [brojlokacija, setBrojlokacija] = useState('');

	const [selectedOption, setSelectedOption] = useState(null);
	const [huntingclubs, setHuntingClubs] = useState(null);
	
	const [selectedoptionvrstaclanstva, setSelectedOptionVrstaClanstva] = useState('Aktivni');
	const [vrstaclanstva, setVrstaClanstva] = useState('Aktivni');
	
	const [huntingclubsdataloaded, setHuntingClubsDataLoaded] = useState(null);
	const [selecthuntingclubsdataloaded, setSelectHuntingClubsDataLoaded] = useState(null);
	const [awardtypeId, setAwardTypeId] = useState('1');
	const [options, setOptions] = useState('');
	
	const [checkedlovackilist, setCheckedLovaciList] = useState(true);
	const [checkedclanskupstine, setCheckedClanSkupstine] = useState(false);
	const [checkedgrupovodja, setCheckedGrupovodja] = useState(false);
	
  const [hunterid, setHunterId] = useState(0);
	
  const [showbuildingcreate, setShowBuildingCreate] = useState('');

  const [huntingclub, setHuntingClub] = useState('');
	
  const [loading, setLoading] = useState(false);
	
  const [showreport, setShowReport] = useState(false);
	
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');
  
  const [members, setMembers] = useState([]);
  
  const [hunter, setHunter] = useState('');
  
  const [izabran, setIzabran] = useState('');
  
  const [dataloaded, setDataLoaded] = useState(false);

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  
  const { user: currentUser } = useSelector((state) => state.auth);
  
  const [checked, setChecked] = useState(true);
  
  const [subscriberime, setSubscriberIme] = useState(0);
  
  const [subscriberprezime, setSubscriberPrezime] = useState(0);
  
  const [subscribermjesto, setSubscriberMjesto] = useState(0);
  
  const [subscriberdrzava, setSubscriberDrzava] = useState(0);
	
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
	
  const handleChange = (event, id) => {
		
  axios.post("https://gpsdogstracking.com:3000/api/shared_devices/",
		{
		"deviceId": 1,
		"subscriber": 1,
		}
	).then(() => {
		// getAllHunters();
		//objectWithSpecificId.blokiran = !objectWithSpecificId.blokiran;
	});
  };
	  
	useEffect(() => {
		setSubscriberIme(localStorage.getItem('subscriberime'));
		setSubscriberPrezime(localStorage.getItem('subscriberprezime'));
		setSubscriberMjesto(localStorage.getItem('subscribermjesto'));
		setSubscriberDrzava(localStorage.getItem('subscriberdrzava'));
		
		setIme(localStorage.getItem('ime'));
        setTip(localStorage.getItem('tip'));
        setIMEI(localStorage.getItem('IMEI'));
        setTiptrackera(localStorage.getItem('tiptrackera'));
	
		if (!dataloaded) {
			getAllHunters();
			const role = currentUser.roles[0];
			const rolenumber = role.slice(10);
		}
		
	}, []);
	
	  const getAllHunters = async () => {
      try {
        const response = await axios.get("https://gpsdogstracking.com:3000/api/subscribers");
        await setMembers(response.data);
		setDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
      
  const handleRefresh = (event, id) => {  
	setShowBuildingCreate(!showbuildingcreate);
	getAllHunters();
  };
	
  console.log(currentUser);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  const setData = (data) => {
  console.log(data);
  
  const { id, ime, prezime, telefon, godiste, mjesto, drzava } = data;
  
  setSubscriberId(id);
  setSubscriberIme(ime);
  setSubscriberPrezime(prezime);
  setSubscriberMjesto(mjesto);
  setSubscriberDrzava(drzava);
  
  }
  
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
	console.log(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = members.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  
  const handleClickShow = (event, id) => {
	console.log(id);
	setHunterId(id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;

  const filteredUsers = applySortFilter(members, getComparator(order, orderBy), filterName, orderBy);

  const isNotFound = !filteredUsers.length && !!filterName;
  
  var today = new Date();

  const datum ='Datum: ' +  today.getDate()  + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + '. god.';
  
	const getHuntingClubsAll = async () => {
      try {
		const response = await axios.get(SERVER_URL + `/huntingclubs/${id}`);
        setHuntingClubs(response.data);
		setHuntingClubsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
	};
	
	const FillSelectHuntingClubsAll = async () => {
      try {
		setSelectHuntingClubsDataLoaded(true);
		const clubs = [];
		huntingclubs.map((huntingclub, index) => ( clubs.push({ value: huntingclub.id, label: huntingclub.naziv, icon: huntingclub.flag })));
		console.log(clubs);
		setOptions(clubs);
      } catch (err) {
        console.log("error");
      }
	};

    const handleChangeHuntingClub = e => {
    	setSelectedOption(e);
		console.log(e);
		//setHuntingClubId(e.value);
  	}	

    const handleChangeVrstaClanstva = e => {
    	setSelectedOptionVrstaClanstva(e);
		console.log(e);
		setVrstaClanstva(e.value);
  	}

	const handleChangeCheckLovackiList = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedLovaciList(event.target.checked);
	};
	
	const handleChangeCheckClanSkupstine = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedClanSkupstine(event.target.checked);
	};
	
	const handleChangeCheckGrupovodja = (event: React.ChangeEvent<HTMLInputElement>) => {
		setBlokiran(event.target.checked);
	};
	
	const optionsvrstaclanstva = [
		{ value: "Aktivni", label: "Aktivni", icon: ""},
		{ value: "Pionir", label: "Pionir", icon: ""},
		{ value: "Počasni", label: "Počasni", icon: ""},
	];
		
	const postData = () => {	
		console.log(id);
		console.log(subscriberId);
		axios.put(SERVER_URL + "/devices/" + id,
			{
				"subscriberId": subscriberId,
			}
			).then(() => {
				//props.handler();
            navigate('/dashboard/HuntersReportAll')
        })
	}
	
  const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  selectimage: {
    margin: 0,
	paddingTop : 0,
	padding : 0,
	height: 40,
	paddingHorizontal: 10,
  },
  selecttext: {
    margin: 3,
    fontSize: 16,
    textAlign: 'justify',
	paddingHorizontal: 20,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    width: "10%", 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
  });
  
  const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
  }));
	
  const customStyles = {
  control: base => ({
    ...base,
	width: 300,
    height: 45,
    minHeight: 25,
	fontSize: 16,
  })
};
  
  const { Option } = components;
  const IconOption = props => (
	<Option {...props}>
	<TableRow style={styles.selectimage}>
	
	<TableCell style={styles.selectimage} align="left">
	
	    <Stack direction="row" alignItems="center" spacing={2}>
		
            <Avatar alt={props.data.label} src={props.data.icon} />
							
			<Typography style={styles.textmedium} variant="subtitle2" noWrap>
				
			</Typography>
			
        </Stack>
						  
	</TableCell>
	
	<TableCell style={styles.selectimage} align="left">
	<Typography style={styles.selecttext} variant="subtitle2" noWrap>
	{props.data.label}
	</Typography>
	</TableCell>
							
	</TableRow>
	</Option>
  );
  
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
		
    return (
		<Container maxWidth="xl">
	    <Typography variant="subtitle2" noWrap>
			Editovanje uređaja
		</Typography>
        <Card>
		  
		    <TableContainer sx={{ minWidth: 1000 }}>
			
              <Table>
			  
                <TableBody>
        
                <TableRow>
					<TableCell component="th" scope="row" >
						<Label>Device ID</Label>
							<TextField
							required
							defaultValue=""
							value={id}
							onChange={(e) => setId(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" >
						<Label>Ime</Label>
							<TextField
							required
							defaultValue=""
							value={ime}
							onChange={(e) => setIme(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" >
						<Label>IMEI</Label>
							<TextField
							required
							defaultValue=""
							value={IMEI}
							onChange={(e) => setIMEI(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
				</TableRow>
				
				<TableRow>	
					<TableCell component="th" scope="row" >
						<Label>Subscriber ID</Label>
							<TextField
							required
							defaultValue=""
							value={subscriberId}
							onChange={(e) => setSubscriberId(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>	
					
					<TableCell component="th" scope="row" >
						<Label>Ime</Label>
							<TextField
							required
							defaultValue=""
							value={subscriberime}
							onChange={(e) => setSubscriberIme(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" >
						<Label>Prezime</Label>
							<TextField
							required
							defaultValue=""
							value={subscriberprezime}
							onChange={(e) => setSubscriberPrezime(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" >
						<Button onClick={postData} type='submit'>Spasi</Button>
                     </TableCell>			
                </TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
        </Card>
		
		<Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
				  color='#002884'
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={members.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, ime, prezime, telefon, godiste, mjesto, drzava, username, password, datumregistracije, blokiran } = row;  
					
                    const selectedUser = selected.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
					    <TableCell component="th" scope="row" >
						  <Typography variant="subtitle2" noWrap>
							{id}
                          </Typography>
                        </TableCell>
					  
                        <TableCell component="th" scope="row" >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={ime} src={"/assets/images/photos/photo_" + id + ".jpg"} />
                          </Stack>
                        </TableCell>
						
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{ime}
						</Typography>
						</TableCell>

                        <TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{prezime}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{mjesto}
						</Typography>
						</TableCell>	

						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{drzava}
						</Typography>
						</TableCell>	
	
						<TableCell align="left">
						<Typography variant="subtitle2" noWrap>
						{datumregistracije}
						</Typography>
						</TableCell>							
												
						<TableCell> 
						<Button onClick={() => setData(row)}>Select</Button>
						</TableCell>						
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        </Container>
    )
}